module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/safe-buffer/browser.js
// module id = 412
// module chunks = 13